import { useLanguage } from '../context/LanguageContext';
import { useTheme } from '../context/ThemeContext';
import { FileText, Scale, AlertTriangle, CreditCard, Ban, RefreshCw, ShieldCheck, Gavel, Mail, ArrowLeft } from 'lucide-react';
import { Link } from 'react-router-dom';

export default function TermsOfService() {
  const { language } = useLanguage();
  const { isDarkMode } = useTheme();

  const sections = [
    {
      icon: FileText,
      title: language === 'ar' ? 'قبول الشروط' : 'Acceptance of Terms',
      content: language === 'ar'
        ? 'باستخدامك لمنصة CloudGM Business، فإنك توافق على الالتزام بهذه الشروط والأحكام. إذا كنت لا توافق على أي جزء من هذه الشروط، يرجى عدم استخدام المنصة. نحتفظ بالحق في تعديل هذه الشروط في أي وقت، وسيتم إخطارك بأي تغييرات جوهرية.'
        : 'By using the CloudGM Business platform, you agree to be bound by these terms and conditions. If you do not agree to any part of these terms, please do not use the platform. We reserve the right to modify these terms at any time, and you will be notified of any material changes.'
    },
    {
      icon: ShieldCheck,
      title: language === 'ar' ? 'متطلبات الحساب' : 'Account Requirements',
      content: language === 'ar'
        ? 'يجب أن يكون عمرك 18 عاماً على الأقل لإنشاء حساب. أنت مسؤول عن الحفاظ على سرية معلومات حسابك وكلمة المرور. يجب تقديم معلومات دقيقة وحديثة عند التسجيل. يحق لنا تعليق أو إنهاء حسابك إذا انتهكت هذه الشروط.'
        : 'You must be at least 18 years old to create an account. You are responsible for maintaining the confidentiality of your account information and password. You must provide accurate and current information when registering. We reserve the right to suspend or terminate your account if you violate these terms.'
    },
    {
      icon: Scale,
      title: language === 'ar' ? 'استخدام المنصة' : 'Platform Usage',
      content: language === 'ar'
        ? 'يُسمح باستخدام المنصة للأغراض التجارية المشروعة فقط. يجب الالتزام بجميع القوانين واللوائح المعمول بها في دولة الإمارات العربية المتحدة. يُحظر استخدام المنصة لأي أنشطة غير قانونية أو احتيالية أو مضللة.'
        : 'The platform may only be used for legitimate commercial purposes. You must comply with all applicable laws and regulations in the United Arab Emirates. Using the platform for any illegal, fraudulent, or misleading activities is prohibited.'
    },
    {
      icon: Ban,
      title: language === 'ar' ? 'المحتوى المحظور' : 'Prohibited Content',
      content: language === 'ar'
        ? 'يُحظر نشر منتجات أو خدمات غير قانونية أو مقلدة أو مسروقة. يُمنع نشر محتوى مسيء أو تمييزي أو ينتهك حقوق الآخرين. يُحظر الإعلان عن منتجات أو خدمات وهمية أو مضللة. نحتفظ بالحق في إزالة أي محتوى ينتهك هذه السياسات.'
        : 'Publishing illegal, counterfeit, or stolen products or services is prohibited. Posting offensive, discriminatory content or content that violates others\' rights is forbidden. Advertising fake or misleading products or services is prohibited. We reserve the right to remove any content that violates these policies.'
    },
    {
      icon: CreditCard,
      title: language === 'ar' ? 'الرسوم والمدفوعات' : 'Fees & Payments',
      content: language === 'ar'
        ? 'قد تفرض المنصة رسوماً على بعض الخدمات، وسيتم إبلاغك بها مسبقاً. جميع الرسوم غير قابلة للاسترداد إلا في الحالات المنصوص عليها صراحة. أنت مسؤول عن جميع الضرائب المطبقة على معاملاتك. نحتفظ بالحق في تغيير هيكل الرسوم مع إشعار مسبق.'
        : 'The platform may charge fees for certain services, and you will be informed in advance. All fees are non-refundable except in cases explicitly stated. You are responsible for all applicable taxes on your transactions. We reserve the right to change the fee structure with prior notice.'
    },
    {
      icon: AlertTriangle,
      title: language === 'ar' ? 'إخلاء المسؤولية' : 'Disclaimer',
      content: language === 'ar'
        ? 'يتم تقديم المنصة "كما هي" دون أي ضمانات صريحة أو ضمنية. لا نتحمل مسؤولية أي خسائر أو أضرار ناتجة عن استخدام المنصة. لا نضمن دقة أو اكتمال المعلومات المقدمة من المستخدمين الآخرين. المعاملات بين المستخدمين تتم على مسؤوليتهم الخاصة.'
        : 'The platform is provided "as is" without any express or implied warranties. We are not liable for any losses or damages resulting from the use of the platform. We do not guarantee the accuracy or completeness of information provided by other users. Transactions between users are conducted at their own risk.'
    },
    {
      icon: RefreshCw,
      title: language === 'ar' ? 'التعديلات والإنهاء' : 'Modifications & Termination',
      content: language === 'ar'
        ? 'نحتفظ بالحق في تعديل أو تعليق أو إنهاء المنصة أو أي جزء منها في أي وقت. يمكنك إنهاء حسابك في أي وقت عن طريق التواصل معنا. عند الإنهاء، قد يتم حذف بياناتك وفقاً لسياسة الخصوصية الخاصة بنا.'
        : 'We reserve the right to modify, suspend, or terminate the platform or any part of it at any time. You may terminate your account at any time by contacting us. Upon termination, your data may be deleted in accordance with our Privacy Policy.'
    },
    {
      icon: Gavel,
      title: language === 'ar' ? 'القانون الحاكم' : 'Governing Law',
      content: language === 'ar'
        ? 'تخضع هذه الشروط وتُفسر وفقاً لقوانين دولة الإمارات العربية المتحدة. أي نزاعات تنشأ عن هذه الشروط أو استخدام المنصة يتم حلها في محاكم دولة الإمارات العربية المتحدة. توافق على الخضوع للاختصاص القضائي الحصري لهذه المحاكم.'
        : 'These terms are governed by and construed in accordance with the laws of the United Arab Emirates. Any disputes arising from these terms or the use of the platform shall be resolved in the courts of the UAE. You agree to submit to the exclusive jurisdiction of these courts.'
    }
  ];

  const highlights = [
    {
      title: language === 'ar' ? 'العمر المطلوب' : 'Age Requirement',
      value: language === 'ar' ? '18+ سنة' : '18+ years'
    },
    {
      title: language === 'ar' ? 'القانون المطبق' : 'Applicable Law',
      value: language === 'ar' ? 'قوانين الإمارات' : 'UAE Laws'
    },
    {
      title: language === 'ar' ? 'آخر تحديث' : 'Last Updated',
      value: language === 'ar' ? 'ديسمبر 2024' : 'December 2024'
    }
  ];

  return (
    <div className={`min-h-screen cgm-page`}>
      {/* Compact Hero Section */}
      <section className="relative overflow-hidden py-8 sm:py-10">
        {/* Background Effects */}
        <div className="absolute inset-0 pointer-events-none">
          <div className={`absolute inset-0 ${isDarkMode ? 'bg-gradient-to-r from-[#0F172A] to-[#1E293B]' : 'bg-gradient-to-r from-[#38BDF8] to-[#F97316]'}`} />
          <div className="absolute top-0 end-0 w-64 h-64 rounded-full bg-white/10 blur-3xl" />
          <div className="absolute bottom-0 start-0 w-48 h-48 rounded-full bg-white/10 blur-3xl" />
        </div>
        
        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
          {/* Back Button */}
          <Link 
            to="/" 
            className="inline-flex items-center gap-2 text-white/80 hover:text-white mb-4 transition-colors"
          >
            <ArrowLeft className="h-4 w-4 rtl:rotate-180" />
            <span className="text-sm">{language === 'ar' ? 'الرئيسية' : 'Home'}</span>
          </Link>
          
          <div className="text-center">
            <div className="w-16 h-16 mx-auto glass-card rounded-2xl flex items-center justify-center mb-4">
              <Scale className="h-8 w-8 text-white" />
            </div>
            <h1 className="text-2xl sm:text-3xl lg:text-4xl font-bold text-white mb-3" data-testid="terms-title">
              {language === 'ar' ? 'شروط الخدمة' : 'Terms of Service'}
            </h1>
            <p className="text-base text-white/80 max-w-2xl mx-auto">
              {language === 'ar'
                ? 'يرجى قراءة هذه الشروط بعناية قبل استخدام منصة CloudGM Business'
                : 'Please read these terms carefully before using the CloudGM Business platform'}
            </p>
          </div>
        </div>
      </section>

      {/* Highlights - Compact Cards */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 -mt-5">
        <div className={`rounded-2xl shadow-xl p-4 grid grid-cols-3 gap-3 border ${
          isDarkMode 
            ? 'bg-[#131B2C] border-white/10' 
            : 'bg-white border-black/5'
        }`}>
          {highlights.map((item, index) => (
            <div key={index} className="text-center">
              <p className={`text-xs ${isDarkMode ? 'text-gray-400' : 'text-gray-500'}`}>{item.title}</p>
              <p className={`text-base font-bold ${isDarkMode ? 'text-white' : 'text-[#0F172A]'}`}>{item.value}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Content */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-10">
        <div className={`rounded-2xl shadow-lg p-5 sm:p-8 space-y-6 border ${
          isDarkMode 
            ? 'bg-[#131B2C] border-white/10' 
            : 'bg-white border-black/5'
        }`}>
          {/* Introduction */}
          <div className={`border-b pb-6 ${isDarkMode ? 'border-white/10' : 'border-gray-100'}`}>
            <p className={`leading-relaxed text-base ${isDarkMode ? 'text-gray-300' : 'text-gray-600'}`}>
              {language === 'ar'
                ? 'مرحباً بك في CloudGM Business. تحكم شروط الخدمة هذه استخدامك للمنصة وجميع الخدمات المرتبطة بها. من خلال الوصول إلى المنصة أو استخدامها، فإنك تقر بأنك قرأت وفهمت ووافقت على الالتزام بهذه الشروط.'
                : 'Welcome to CloudGM Business. These Terms of Service govern your use of the platform and all related services. By accessing or using the platform, you acknowledge that you have read, understood, and agreed to be bound by these terms.'}
            </p>
          </div>

          {/* Sections */}
          {sections.map((section, index) => (
            <div 
              key={index} 
              className={`flex gap-4 sm:gap-5 p-4 rounded-xl transition-all duration-300 hover:-translate-y-0.5 ${
                isDarkMode 
                  ? 'bg-white/5 hover:bg-white/10 border border-white/5' 
                  : 'bg-gray-50 hover:bg-gray-100/80 border border-gray-100'
              }`}
            >
              <div className="flex-shrink-0">
                <div className={`w-11 h-11 rounded-xl flex items-center justify-center ${
                  isDarkMode 
                    ? 'bg-gradient-to-br from-[#38BDF8]/20 to-[#F97316]/20 border border-white/10' 
                    : 'gradient-primary'
                }`}>
                  <section.icon className={`h-5 w-5 ${isDarkMode ? 'text-[#38BDF8]' : 'text-white'}`} />
                </div>
              </div>
              <div className="flex-1">
                <h2 className={`text-lg font-bold mb-2 ${isDarkMode ? 'text-white' : 'text-[#0F172A]'}`}>
                  {section.title}
                </h2>
                <p className={`leading-relaxed text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
                  {section.content}
                </p>
              </div>
            </div>
          ))}

          {/* Important Notice */}
          <div className={`rounded-xl p-5 mt-6 border ${
            isDarkMode 
              ? 'bg-amber-500/10 border-amber-500/30' 
              : 'bg-amber-50 border-amber-200'
          }`}>
            <div className="flex items-start gap-4">
              <div className="w-10 h-10 rounded-xl bg-gradient-to-br from-amber-500 to-orange-500 flex items-center justify-center flex-shrink-0">
                <AlertTriangle className="h-5 w-5 text-white" />
              </div>
              <div>
                <h3 className={`font-bold mb-2 ${isDarkMode ? 'text-amber-400' : 'text-amber-800'}`}>
                  {language === 'ar' ? 'ملاحظة مهمة' : 'Important Notice'}
                </h3>
                <p className={`text-sm ${isDarkMode ? 'text-amber-300/80' : 'text-amber-700'}`}>
                  {language === 'ar'
                    ? 'استمرارك في استخدام المنصة بعد أي تعديلات على هذه الشروط يعني قبولك للشروط المعدلة. ننصحك بمراجعة هذه الصفحة بشكل دوري للاطلاع على أي تحديثات.'
                    : 'Your continued use of the platform after any modifications to these terms constitutes acceptance of the modified terms. We recommend reviewing this page periodically for any updates.'}
                </p>
              </div>
            </div>
          </div>

          {/* Contact */}
          <div className={`rounded-xl p-5 mt-6 border ${
            isDarkMode 
              ? 'bg-gradient-to-r from-[#38BDF8]/10 to-[#F97316]/10 border-white/10' 
              : 'bg-gradient-to-r from-[#38BDF8]/5 to-[#F97316]/5 border-[#38BDF8]/20'
          }`}>
            <div className="flex items-center gap-3 mb-3">
              <div className="w-10 h-10 rounded-xl gradient-primary flex items-center justify-center">
                <Mail className="h-5 w-5 text-white" />
              </div>
              <h2 className={`text-lg font-bold ${isDarkMode ? 'text-white' : 'text-[#0F172A]'}`}>
                {language === 'ar' ? 'تواصل معنا' : 'Contact Us'}
              </h2>
            </div>
            <p className={`mb-4 text-sm ${isDarkMode ? 'text-gray-400' : 'text-gray-600'}`}>
              {language === 'ar'
                ? 'إذا كان لديك أي أسئلة حول شروط الخدمة هذه، يرجى التواصل معنا:'
                : 'If you have any questions about these Terms of Service, please contact us:'}
            </p>
            <div className={`space-y-2 text-sm ${isDarkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              <p><strong className="text-gradient">{language === 'ar' ? 'البريد الإلكتروني:' : 'Email:'}</strong> support@cloudgm.business</p>
              <p><strong className="text-gradient">{language === 'ar' ? 'الهاتف:' : 'Phone:'}</strong> <span dir="ltr">+971 50 151 1917</span></p>
              <p><strong className="text-gradient">{language === 'ar' ? 'الموقع:' : 'Website:'}</strong> www.cloudgm.business</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
